import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { notificationsApi, type AppNotification } from '../lib/domain';
import { PushToggle } from '../components/PushToggle';
import { notifyUnreadChanged } from '../lib/unread';

export function NotificationsPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState<AppNotification[] | null>(null);

  const load = useCallback(async () => {
    try {
      setItems((await notificationsApi.list()).notifications);
    } catch {
      setItems([]);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  async function open(n: AppNotification) {
    if (!n.readAt) {
      await notificationsApi.markRead(n.id).catch(() => undefined);
      notifyUnreadChanged();
    }
    if (n.url) navigate(n.url);
    else await load();
  }

  async function markAll() {
    await notificationsApi.markAllRead().catch(() => undefined);
    notifyUnreadChanged();
    await load();
  }

  return (
    <div className="stack">
      <div className="row between">
        <h1>Benachrichtigungen</h1>
        <button onClick={markAll} disabled={!items?.some((n) => !n.readAt)}>
          Alle als gelesen markieren
        </button>
      </div>
      <div className="card">
        <PushToggle />
      </div>
      {items === null ? (
        <p>Lade…</p>
      ) : items.length === 0 ? (
        <p className="muted">Keine Benachrichtigungen.</p>
      ) : (
        <ul className="list-reset stack">
          {items.map((n) => (
            <li key={n.id} className="card" style={n.readAt ? { opacity: 0.7 } : { borderColor: 'var(--color-primary, #1d5c3e)' }}>
              <button type="button" onClick={() => open(n)} style={{ all: 'unset', cursor: 'pointer', display: 'block', width: '100%' }}>
                <div className="row between">
                  <strong>{n.title}</strong>
                  {!n.readAt && <span className="badge">Neu</span>}
                </div>
                <div>{n.body}</div>
                <div className="muted">{new Date(n.createdAt).toLocaleString('de-DE')}</div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
